import { apiSlice } from "../api/apiSlice";

export const skillsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAiSkills: builder.query({
      query: () => ({ url: "/skills?category=ai" }),
    }),
  }),
});

export const { useGetAiSkillsQuery } = skillsApiSlice;
